<template>
  <RouterView />
</template>

<script setup>
import { eventActionBus } from '@/composables/EventActionBus';
import { websocketManager } from '@/composables/WebSocketManager';
import { useSystemStore } from '@/stores/SystemStore';
import { onUnmounted } from 'vue';
import router from '@/router'

const systemStore = useSystemStore()
await router.isReady()
const shouldApplyTheme = !router.currentRoute.value.meta.isAffiliate
await systemStore.FetchLayoutSettings(true, shouldApplyTheme)

websocketManager.connect('owner_notifications', 'ws/notifications/')
const ws_actions = {
	update_layout: systemStore.FetchLayoutSettings,
}

const stop = eventActionBus.on('owner_notifications', (actionName, payload) => {
  console.log(`[BaseLayout] Evento recebido do bus: ${actionName}`);
  if (ws_actions[actionName]) {
    ws_actions[actionName](payload);
  }
  return true
})

onUnmounted(() => {
  stop()
  websocketManager.disconnect('owner_notifications')
})
</script>

<style scoped>

</style>
